import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiClock, FiPhone, FiMail, FiNavigation } = FiIcons;

const DealershipInfo = () => {
  const hours = [
    { day: 'Monday - Friday', time: '9:00 AM - 7:00 PM' },
    { day: 'Saturday', time: '10:00 AM - 5:00 PM' },
    { day: 'Sunday', time: 'Closed' }
  ];

  const handleGetDirections = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=550+Windmill+Rd+Dartmouth+NS+B3B+1B3', '_blank');
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-4">
      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 shadow-xl">
        <h3 className="text-xl font-bold text-white mb-4 flex items-center">
          <SafeIcon icon={FiMapPin} className="w-5 h-5 mr-2 text-blue-500" />
          Visit Carson Exports
        </h3>
        <div className="space-y-4">
          <div>
            <p className="text-white font-semibold">Carson Exports - Used Car Dealer</p>
            <p className="text-gray-400">550 Windmill Rd</p>
            <p className="text-gray-400">Dartmouth, NS B3B 1B3</p>
          </div>
          <div className="flex space-x-3">
            <button onClick={handleGetDirections} className="flex-1 flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg font-bold transition-all">
              <SafeIcon icon={FiNavigation} className="w-4 h-4" />
              <span>Directions</span>
            </button>
            <button onClick={() => window.location.href='tel:+18337063089'} className="flex-1 flex items-center justify-center space-x-2 bg-gray-700 hover:bg-gray-600 text-white px-4 py-3 rounded-lg font-bold transition-all">
              <SafeIcon icon={FiPhone} className="w-4 h-4" />
              <span>Call Us</span>
            </button>
          </div>
        </div>
      </div>

      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 shadow-xl">
        <h3 className="text-xl font-bold text-white mb-4 flex items-center">
          <SafeIcon icon={FiClock} className="w-5 h-5 mr-2 text-blue-500" />
          Operating Hours
        </h3>
        <div className="space-y-3">
          {hours.map((item, index) => (
            <div key={index} className="flex justify-between items-center border-b border-gray-700/50 pb-2">
              <span className="text-gray-400">{item.day}</span>
              <span className="text-white font-medium">{item.time}</span>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default DealershipInfo;